import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ValueWithRandom } from "../../ValueWithRandom";
export var ParticlesBounceFactor = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(ParticlesBounceFactor, _ValueWithRandom);

  var _super = _createSuper(ParticlesBounceFactor);

  function ParticlesBounceFactor() {
    var _this;

    _classCallCheck(this, ParticlesBounceFactor);

    _this = _super.call(this);
    _this.random.minimumValue = 0.1;
    _this.value = 1;
    return _this;
  }

  return _createClass(ParticlesBounceFactor);
}(ValueWithRandom);